// extracted by mini-css-extract-plugin
export default {"policieGroup":"ask-policie_policieGroup__vR3Js","policieElement":"ask-policie_policieElement__0y3ww","policieLabel":"ask-policie_policieLabel__tvXX4"};